import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e61e95d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2e61e95d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e61e95d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e61e95d')) {
      api.createRecord('2e61e95d', component.options)
    } else {
      api.reload('2e61e95d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e61e95d&scoped=true", function () {
      api.rerender('2e61e95d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/index.vue"
export default component.exports